import { render } from "./SessionNew.vue?vue&type=template&id=c31fe9e2"
import script from "./SessionNew.vue?vue&type=script&lang=js"
export * from "./SessionNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__